import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import {
  Box,
  Button,
  IconButton,
  Tooltip,
  Typography,
} from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import ArchiveIcon from '@material-ui/icons/Archive';
import CustomModal from '../../../../components/modal/CustomModal';
import { archiveUser } from '../../../../actions/user.actions';

const DeleteUser = ({ userId }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const modalRef = useRef(null);
  const { role, user } = useSelector((store) => store.user);
  const currentUserId = user?.user_info?.id;
  const isSelf =
    currentUserId !== undefined &&
    currentUserId !== null &&
    currentUserId !== '' &&
    String(currentUserId) === String(userId);
  const disabled = role !== 'Admin' || isSelf;
  const tooltipTitle = isSelf
    ? 'You cannot archive your own account'
    : role !== 'Admin'
    ? 'Archive'
    : 'Archive';

  const handleArchive = () => {
    dispatch(archiveUser(userId))
      .then(() => {
        enqueueSnackbar('User was archived', {
          variant: 'success',
        });
      })
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.detail ||
          error?.response?.data?.details ||
          error?.message ||
          'Failed to archive user. Please try again.';
        enqueueSnackbar(errorMessage, {
          variant: 'error',
        });
      });
    modalRef.current.close();
  };

  const handleClose = () => {
    modalRef.current.close();
  };

  return (
    <CustomModal
      renderOpen={(handleClickOpen) => (
        <Tooltip title={tooltipTitle}>
          <span>
            <IconButton
              onClick={handleClickOpen}
              disabled={disabled}
              id={`user_archive_button_${userId}`}
            >
              <ArchiveIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}
      ref={modalRef}
    >
      <Box textAlign="center">
        <Box>
          <ErrorOutlineIcon style={{ width: 67, height: 67, color: 'red' }} />
        </Box>
        <Typography variant="h6" color="primary">
          <Box fontWeight="bold">Archive User</Box>
        </Typography>
        <Box mt={2} />
        <Typography variant="body1">
          Are you sure you want to archive this user? They will lose portal
          access. Past activity remains for reports. This does not permanently
          delete the account.
        </Typography>
        <Box mt={1} />
        <Typography variant="body1">
          ¿Está seguro de que desea archivar este usuario? Perderá el acceso al
          portal. La actividad anterior permanece en los reportes. Esto no
          elimina permanentemente la cuenta.
        </Typography>
        <Box mt={7}>
          <Button
            id={`user_archive_cancel_button_${userId}`}
            variant="outlined"
            size="large"
            color="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Box mr={2} component="span" />
          <Button
            id={`user_archive_confirm_button_${userId}`}
            variant="contained"
            size="large"
            style={{
              color: '#fff',
              backgroundColor: '#d32f2f',
            }}
            onClick={handleArchive}
          >
            Archive
          </Button>
        </Box>
      </Box>
    </CustomModal>
  );
};

export default DeleteUser;
